import { db } from "./firebase";
import {
  collection, addDoc, getDocs, updateDoc, deleteDoc,
  doc, query, orderBy, serverTimestamp, writeBatch
} from "firebase/firestore";

const COL = "shipments";

export function generateShipmentId() {
  const ts   = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).substring(2, 5).toUpperCase();
  return `LBM-SHP-${ts}-${rand}`;
}

// Create shipment — saves the real tracking number on every package
export async function createShipment(packageIds, trackingNumber, notes) {
  const batch   = writeBatch(db);
  const shipRef = doc(collection(db, COL));

  batch.set(shipRef, {
    trackingNumber,
    packageIds,
    status:    "Shipped",
    notes:     notes || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  packageIds.forEach(id => {
    batch.update(doc(db, "packages", id), {
      status:           "Shipped",
      shipmentId:       shipRef.id,
      shipmentTracking: trackingNumber, // ← real FedEx/UPS/USPS number
      updatedAt:        serverTimestamp(),
    });
  });

  await batch.commit();
  return shipRef.id;
}

export async function getAllShipments() {
  const q    = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// Update shipment tracking + also update all packages inside
export async function updateShipment(shipmentId, packageIds, trackingNumber, notes) {
  const batch = writeBatch(db);

  batch.update(doc(db, COL, shipmentId), {
    trackingNumber,
    notes:     notes || "",
    updatedAt: serverTimestamp(),
  });

  // Update shipmentTracking on every package in this shipment
  (packageIds || []).forEach(id => {
    batch.update(doc(db, "packages", id), {
      shipmentTracking: trackingNumber,
      updatedAt:        serverTimestamp(),
    });
  });

  await batch.commit();
}

export async function markShipmentDelivered(shipmentId, packageIds) {
  const batch = writeBatch(db);

  batch.update(doc(db, COL, shipmentId), {
    status:      "Delivered",
    deliveredAt: serverTimestamp(),
    updatedAt:   serverTimestamp(),
  });

  packageIds.forEach(id => {
    batch.update(doc(db, "packages", id), {
      status:    "Delivered",
      updatedAt: serverTimestamp(),
    });
  });

  await batch.commit();
}

export async function deleteShipment(shipmentId, packageIds) {
  const batch = writeBatch(db);

  batch.delete(doc(db, COL, shipmentId));

  packageIds.forEach(id => {
    batch.update(doc(db, "packages", id), {
      status:           "Received",
      shipmentId:       null,
      shipmentTracking: null,
      updatedAt:        serverTimestamp(),
    });
  });

  await batch.commit();
}
